/**
 * Payments (WP4-BILLING, BUILD-PLAN M21): text-to-pay links, posting,
 * reversals, payment plans and the financing waterfall, at
 * `/billing/payments`. One office or All offices; money always posts to one
 * office, picked per family.
 *
 * Deep links (any screen can open the right drawer):
 *   /billing/payments?post=<patientId>&at=<officeId>   Post payment
 *   /billing/payments?link=<patientId>&at=<officeId>   Text-to-pay
 *   /billing/payments?plan=<planId>&at=<officeId>      a payment plan
 *   /billing/payments?tab=links|payments|plans
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'payments',
    title: 'Payments',
    version: '0.1.0',
    owner: 'WP4-BILLING',
    entitlementKey: null,
    permissions: [
      'ledger.view',
      'money.view',
      'ledger.post_payment',
      'ledger.adjust',
      'settings.manage',
    ],
    routes: [
      {
        id: 'payments',
        path: '/billing/payments',
        title: 'Payments',
        officeScope: 'location-or-all',
        permission: 'ledger.view',
        readsPhi: true,
      },
      {
        id: 'collections',
        path: '/billing/collections',
        title: 'Collections',
        officeScope: 'location',
        permission: 'ledger.view',
        readsPhi: true,
      },
    ],
    commands: [
      {
        id: 'payments.open',
        title: 'Go to Payments',
        keywords: ['payment', 'text to pay', 'pay link', 'payment plan', 'financing', 'refund'],
        routeId: 'payments',
        permission: 'ledger.view',
      },
      {
        id: 'payments.collections',
        title: 'Go to Collections',
        keywords: ['collections', 'bad debt', 'agency', 'promise to pay', 'past due'],
        routeId: 'collections',
        permission: 'ledger.view',
      },
    ],
    shortcuts: [],
    sseEntityKeys: ['payment', 'ledger_entry', 'pay_link', 'payment_plan'],
    phiReadPoints: ['payments.account', 'payments.list'],
  }),
  pages: {
    payments: () => import('./PaymentsPage.js'),
    collections: () => import('./CollectionsPage.js'),
  },
});
